import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'loyaltic-support-products',
  templateUrl: './support-products.component.html',
  styleUrls: ['./support-products.component.scss']
})
export class SupportProductsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
